'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var error = function error(type) {
  if (!type) throw new Error('Please specify the error type');

  var fn = function fn(_ref) {
    var _ref$fields = _ref.fields,
        fields = _ref$fields === undefined ? [] : _ref$fields,
        _ref$names = _ref.names,
        names = _ref$names === undefined ? [] : _ref$names,
        _ref$message = _ref.message,
        message = _ref$message === undefined ? 'Error of type "' + type + '" occured.' : _ref$message,
        _ref$origin = _ref.origin,
        origin = _ref$origin === undefined ? null : _ref$origin;
    return {
      type: type,
      fields: fields,
      names: names,
      message: message,
      origin: origin
    };
  };

  fn.type = type;
  return fn;
};

var systemError = exports.systemError = function systemError(message) {
  return error('sallyFnError')({
    message: message
  });
};

exports.default = error;